module.exports = __webpack_public_path__ + "img/DW365-032.6919bc9e.jpg";